import { Navigate, useLocation } from "react-router-dom";
import { getFirstAllowedPath, hasPermission } from "../../utils/permissions";

export default function PermissionRoute({
  moduleKey,
  action = "read",
  children,
}) {
  const location = useLocation();

  const allowed = hasPermission(moduleKey, action);

  if (allowed) {
    return children;
  }

  const redirectPath = getFirstAllowedPath();

  if (location.pathname === redirectPath) {
    return null;
  }

  return <Navigate to={redirectPath} replace />;
}